import CategoryCard from '@components/views/landing/common/CategoryCard/CategoryCard';
import IsInViewPort from '@components/ui/IsInViewPort';

import { CategoryCardInfo } from './CategoryPromotion';
import { CardWrapper, DesktopWrapper } from './styled';

export type CategoryPromotionType =
  | 'default'
  | 'hotel'
  | 'userHotelRecommandations'
  | 'tour'
  | 'cruise';

const getTourGridArea = (index: number) => (index === 2 ? 'fillCol' : '');
const getCruiseGridArea = (index: number) => (index === 2 ? 'fillCol' : '');
const getHotelGridArea = (index: number, length: number) => {
  if (index === 0) return 'fillCol';
  else if (index === length - 1) return 'lastItem';
  else return '';
};
const getUserHotelRecommandationsGridArea = (index: number) =>
  index === 0 ? 'fillCol' : '';

const CategoryTypeGetGridAreaMap: Record<
  CategoryPromotionType,
  (index: number, length: number) => string
> = {
  default: () => '',
  tour: getTourGridArea,
  cruise: getCruiseGridArea,
  hotel: getHotelGridArea,
  userHotelRecommandations: getUserHotelRecommandationsGridArea,
};

type Props = {
  data: CategoryCardInfo[];
  type?: CategoryPromotionType;
  onViewVisible?: (item: CategoryCardInfo, position: number) => void;
  onNavigate?: (item: CategoryCardInfo, position: number) => void;
};
const CategoryPromotionDesktop = ({
  data,
  type = 'default',
  onViewVisible,
  onNavigate,
}: Props) => {
  return (
    <DesktopWrapper>
      <div className={type}>
        {data?.map((item, index) => (
          <CardWrapper
            key={index}
            gridArea={CategoryTypeGetGridAreaMap[type]?.(index, data.length)}
          >
            <IsInViewPort
              onViewVisible={() => {
                onViewVisible?.(item, index + 1);
              }}
              cssAll='unset'
            >
              <CategoryCard
                info={item}
                onNavigate={() => onNavigate?.(item, index + 1)}
              />
            </IsInViewPort>
          </CardWrapper>
        ))}
      </div>
    </DesktopWrapper>
  );
};

export default CategoryPromotionDesktop;
